import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import { styled } from '@mui/material/styles'
import { HeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'
import { Tooltip } from '@mui/material'
import { intl } from '../../../../../i18n'

type RefreshButtonProps = {
  onClick: () => void
  disabled?: boolean
}

const StyledIcon = styled(RefreshRoundedIcon)({
  color: colorPalette.monotone[4],
  fontSize: '16px',
})

export const RefreshButton = ({ onClick, disabled }: RefreshButtonProps) => {
  return (
    <Tooltip
      title={intl.formatMessage({
        id: 'versionReport.tooltip.refreshButton',
      })}
    >
      <HeaderIconButton onClick={onClick} disabled={disabled}>
        <StyledIcon />
      </HeaderIconButton>
    </Tooltip>
  )
}
